import React, { FC } from 'react'
import { ResponsiveContainer, XAxis, YAxis, Line, Tooltip, ComposedChart, Area, CartesianGrid, Legend } from 'recharts'
import { useAppContext } from '../../hooks/useAppContext'
import { TIntersection } from '../../types'
import styles from './Charts.module.scss'
import { CustomLegend } from './CustomLegend'
import { CustomTooltip } from './CustomTooltip'
import { getDataWithRange, getIntersectionColor, getIntersections, tickFormat } from './utils'

export const Chart: FC = () => {
	const { chartsValues } = useAppContext()
	const windowWidth = window.innerWidth

	const legendStyle = {
		padding: windowWidth > 768 ? '0 0 3rem 0' : '0 0 .5rem 0', top: '-15px', left: '1%'
	}
	const dataWithRange = getDataWithRange(chartsValues)
	const intersections = getIntersections(chartsValues)

	const filteredIntersections = (intersections as TIntersection[]).filter(
		(d, i) => (i === intersections.length - 1 || d.x !== (intersections[i - 1] as TIntersection)?.x),
	)

	return (
		<div className={styles.chart}>
			<ResponsiveContainer minHeight={450}>
				<ComposedChart data={dataWithRange} width={500}
					height={400}
				>

					<defs>
						<linearGradient id='color'>
							{filteredIntersections.length ? (
								filteredIntersections.map((intersection, i) => {
									const nextIntersection = filteredIntersections[i + 1]
									let closeColor = ""
									let startColor = ""
									const isLast = i === filteredIntersections.length - 1
									if (isLast) {
										closeColor = getIntersectionColor(intersection)
										startColor = getIntersectionColor(intersection, true)
									} else {
										closeColor = getIntersectionColor(intersection)
										startColor = getIntersectionColor(nextIntersection)
									}
									const offset =
										intersection.x /
										(chartsValues.filter(
											(d) =>
												d.before !== undefined && d.after !== undefined
										).length -
											1);
									return (
										<React.Fragment key={i}>
											<stop
												offset={offset}
												stopColor={closeColor}
												stopOpacity={0.9}
											/>
											<stop
												offset={offset}
												stopColor={startColor}
												stopOpacity={0.9}
											/>
										</React.Fragment>
									)
								})
							) : (
									<stop
									offset={0}
									stopColor={
										chartsValues[0].before > chartsValues[0].after ? "#D05151" : '#2FBF69'
									}
								/>
							)}
						</linearGradient>
					</defs>

					<Legend iconType='circle' verticalAlign="top" align='left' height={36} content={<CustomLegend />} wrapperStyle={legendStyle} />
					<Area 
						type='monotone'
						dataKey="range"
						stroke='transperent'
						fill={`url(#color)`}
					/>
					<Line type='monotone' dataKey="before" stroke="#54857C" strokeWidth={5} dot={false} connectNulls />
					<Line type='monotone' dataKey="after" stroke="#FAD865" strokeWidth={5} dot={false} connectNulls />
					<XAxis tickMargin={5} dataKey='date' axisLine={false} width={2} height={20} tickCount={chartsValues.length} tickLine={false} stroke='#54857C'
						padding={{ left: 10 }}
					/>
					<YAxis type="number" tickMargin={10} axisLine={false} tickLine={false} tickCount={7}
						tickFormatter={num => tickFormat(num)} stroke='#54857C' />
					<Tooltip content={<CustomTooltip />} />
					<CartesianGrid vertical={false} strokeDasharray="5" opacity={0.5} />
				</ComposedChart>
			</ResponsiveContainer>
		</div>
	)
}



